export default __webpack_public_path__ + "static/media/(23).489df0c5.jpeg";